export class Building {
    constructor(
      public id: string,
      public name: string,
      public groups: any[],
      public description?: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/buildings/shared/building.model.ts